export default "__VITE_ASSET__DGdaUB_M__"